import TooltipModalBody from "ds/components/TooltipModal/Body";
import { TooltipModalTitle } from "ds/components/TooltipModal/Title";
import ReadMoreDocsLink from "components/ReadMoreDocsLink";
import { getDocsUrl } from "utils/getDocsUrl";

import { StackSettingsGetTooltipHelperReturnType } from "../../types";

export const getWorkflowToolTooltip = (): StackSettingsGetTooltipHelperReturnType => ({
  tooltipInfo: (
    <>
      <TooltipModalTitle>Workflow tool</TooltipModalTitle>
      <TooltipModalBody align="start">
        The tool used to execute the workflow commands. This can be OpenTofu or a custom tool. When a
        custom tool is selected, you must provide a .spacelift/workflow.yml file containing the
        commands to execute.
        <ReadMoreDocsLink docsUrl={getDocsUrl("/vendors/terraform/workflow-tool")} />
      </TooltipModalBody>
    </>
  ),
  tooltipInfoVariant: "modal",
});

export const getExternalStateAccessEnabledTooltip =
  (): StackSettingsGetTooltipHelperReturnType => ({
    tooltipInfo: (
      <>
        <TooltipModalTitle>External state access</TooltipModalTitle>
        <TooltipModalBody align="start">
          Only stacks with Space writer role or users with write permission to this stack's space can access
          the state.
        </TooltipModalBody>
      </>
    ),
    tooltipInfoVariant: "modal",
  });

export const getEnableCPUProfilingTooltip = (): StackSettingsGetTooltipHelperReturnType => ({
  tooltipInfo: (
    <>
      <TooltipModalTitle>CPU profiling</TooltipModalTitle>
      <TooltipModalBody align="start">
        When enabled, Spacelift captures CPU profiles from OpenTofu init, plan, and apply phases.
        Requires OpenTofu 1.10+ at runtime; silently omitted on older versions.
      </TooltipModalBody>
    </>
  ),
  tooltipInfoVariant: "modal",
});

export const getConciseTooltip = (): StackSettingsGetTooltipHelperReturnType => ({
  tooltipInfo: (
    <>
      <TooltipModalTitle>Concise output</TooltipModalTitle>
      <TooltipModalBody align="start">
        When enabled, Spacelift passes -concise to tofu plan/apply/refresh to suppress the
        "Refreshing state..." progress output. Requires OpenTofu 1.7+ at runtime; the flag is
        silently omitted on older versions.
      </TooltipModalBody>
    </>
  ),
  tooltipInfoVariant: "modal",
});
